import { render, staticRenderFns } from "./flex-photo.vue?vue&type=template&id=2bcf8056"
import script from "./flex-photo.vue?vue&type=script&lang=js"
export * from "./flex-photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports